import {NavigationGuardNext} from "vue-router";
import store from "@/store";
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
import FuneralPlanGroupService from "@/services/FuneralPlanGroupService";
import { IFuneralPlanGroup } from "@/shared/domain/funeral-plan-group.model";


const RouteSettings = {
   checkRouteDependecies: (path: string, next:NavigationGuardNext, index = 0) => {
    if(!store.getters.firstLoad) {
      store.commit("saveStateToCache");
    } else {
      RouteSettings.checkForCacheData();
    }
    if(path[0] == '/') {
      path = path.replace('/', '');
    }
    path = path.split('/')[index];
    switch(path) {
      case 'group-parque-brasil':
      case 'filter':
      case 'fornecedor':
      case 'mag-seguros':
        if(!store.getters.getSelectedFuneralPlanGroup && !store.getters.getBeneficiaryDeath) {
          FuneralPlanGroupService.query({
          'lostSomeone.equals': store.getters.getFuneralPlanTab === FuneralPlanTab.LOST_SOMEONE
          }).then((res:any) => {
            const data = res.data;
            if(data) {
              let selectedFuneralPlanGroup;
              if(data.length == 1) {
                selectedFuneralPlanGroup = data[0];
              } else {
                selectedFuneralPlanGroup = data.find((obj:IFuneralPlanGroup) => !obj.bioparque);
              }
              store.commit('changeSelectedFuneralPlanGroup', selectedFuneralPlanGroup);
              if(RouteSettings.checkDependencies(0)) {
                next();
              } else {
                next({path: '/'});
              }
            }
          });
        } else {
          if(RouteSettings.checkDependencies(0)) {
            next();
          } else {
            next({path: '/'});
          }
        }

        break
      case 'repay':
        if(RouteSettings.checkDependencies(0)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'location':
        if(RouteSettings.checkDependencies(1)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      // case 'supplier':
      //   if(RouteSettings.checkDependencies(2)) {
      //     next();
      //   } else {
      //     next({path: '/'});
      //   }
      //   break
      case 'payer':
        if(RouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'payment-method':
        if(RouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'beneficiaries':
        if(RouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'full':
        if(RouteSettings.checkDependencies(2)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pacote':
      case 'dados':
      case 'dados-cliente':
        if(RouteSettings.checkDependencies(3)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pagamento':
        if(RouteSettings.checkDependencies(3)) {
          next();
        } else {
          next({path: '/'});
        }
        break
      case 'pagamento-realizado':
        if(store.getters.getContract || localStorage.getItem("finishedPurchase")) {
          next();
        } else {
          next({path: '/'});
        }
        break
    }
  },
   checkDependencies: (index: number):boolean => {
    let value = true;
    for(let i = 0; i <= index && value; i++) {
      const d = RouteSettings.ifDependencies[i];
      value = d();
    }
    return value;
  },
  ifDependencies: [
    ():boolean => {
      return store.getters.getSelectedFuneralPlanGroup
        || store.getters.getBeneficiaryDeath;
    },
    ():boolean => {
      return store.getters.getBeneficiaryDeath
        || store.getters.getSelectedFuneralPlanGroup.bioparque
        || (store.getters.getFuneralPlanFilterOptions && store.getters.getFuneralPlanFilterOptions.length > 0); //1
    },
    ():boolean => {
      return store.getters.getBeneficiaryDeath
        || store.getters.getSelectedFuneralPlanGroup.bioparque
        || store.getters.getCity
        || store.getters.getStateProvince; //Prevent
    },
    ():boolean => {
      if (store.getters.getFuneralPlanTab === FuneralPlanTab.PREVENT &&
        store.getters.getSelectedFuneralPlanGroup.bioparque) {
        return store.getters.getFuneralPlanSupplier && store.getters.getFuneralPlanHolder;
      }
      return store.getters.getFuneralPlanSupplier; //3
    },
    ():boolean => {
      const finishedPurchase = localStorage.getItem("finishedPurchase");
      return store.getters.getContract || finishedPurchase; //4
    }
  ],
  checkForCacheData: () => {
    if(store.getters.firstLoad) {
      store.commit('updateFirstLoad');
      const cacheDataJson = localStorage.getItem("state");
      if(cacheDataJson) {
        const cacheData = JSON.parse(cacheDataJson);
        if(cacheData["funeralPlanTab"] == store.getters.getFuneralPlanTab) {
          store.commit("updateState", cacheData);
        } else {
          store.commit("resetValues");
        }
      }
    }
  },
  forceToFilterByLegacySupplierCompaniesId: (force = false) => {
    store.commit('changeForceToFilterByLegacySupplierCompaniesId', force ? 104807 : null);
  },
  newStores() {
    store.commit('resetContract');
    store.commit('resetContractPayments');
    store.commit('changePetSupportAdded', false);
    store.commit('changeFuneralPlanFilterOptions', true);
  }
}

export default RouteSettings;
